import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { listPageSelect_template } from '~/components/templates/listPageSelect_template';
import { renderTransmissionsTable } from '~/components/recruiting/transmission-table';
import { html, LpButton, LpFilterBar, LpFilterCell, LpPageHeader, LpSearchInput, raw } from '~/design-system';
import { getTransmissionLiveStatusOption } from '~/utils/transmissionLiveStatus';
export class adminTransmissions_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminTransmissions-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['w-content'];
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        const vm = this.getTemplateViewModel();
        this.pagination = new pagination_template('adminTransmissionsPagination', vm, this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultsInfo = new resultsInfo_template('adminTransmissionsResultInfo', vm, this.caller);
        this.liveFilter = new listPageSelect_template('adminTransmissionsLiveFilter', vm, this.caller);
        this.liveFilter.setLabel('Live status');
        this.liveFilter.setShowLabelPrefix(true);
        this.liveFilter.setIcon('info');
        this.liveFilter.setOptions([
            getTransmissionLiveStatusOption({ id: '1', name: 'Live' }),
            getTransmissionLiveStatusOption({ id: '0', name: 'Not Live' }),
        ]);
        this.liveFilter.bindValue(vm.live);
        this.channelFilter = new listPageSelect_template('adminTransmissionsChannelFilter', vm, this.caller);
        this.channelFilter.setLabel('Channel');
        this.channelFilter.setShowLabelPrefix(true);
        this.channelFilter.setIcon('grid');
        this.channelFilter.bindValue(vm.channel);
        this.typeFilter = new listPageSelect_template('adminTransmissionsTypeFilter', vm, this.caller);
        this.typeFilter.setLabel('Transmission type');
        this.typeFilter.setShowLabelPrefix(true);
        this.typeFilter.setIcon('link');
        this.typeFilter.bindValue(vm.transmissionType);
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            transmissions: ko.observableArray([]),
            live: ko.observable('1'),
            channel: ko.observable(''),
            transmissionType: ko.observable(''),
            name: ko.observable(''),
            onClickCreate: function () { self.caller.createTransmission(); },
            onClickGroups: function () { self.caller.openGroups(); },
            onClickEdit: function (row) { self.caller.editTransmission(row.id); },
            onClickRun: function (row) { self.caller.runTransmission(row.id); },
            onFilterChange: function () { self.caller.filterOnChange(); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            ${LpPageHeader({
            title: 'Transmissions',
            description: 'Manage lead transmission jobs and delivery rules.',
            icon: 'paper-plane-tilt',
            controls: LpFilterBar({
                className: 'transmissions-control-bar',
                controls: html `
                        ${LpFilterCell({
                    children: raw(this.liveFilter.getHtmlBuild()),
                })}

                        ${LpFilterCell({
                    children: raw(this.channelFilter.getHtmlBuild()),
                })}

                        ${LpFilterCell({
                    children: raw(this.typeFilter.getHtmlBuild()),
                })}

                        ${LpFilterCell({
                    search: true,
                    children: LpSearchInput({
                        placeholder: 'Transmission name',
                        attributes: {
                            'data-bind': 'value: name, event: { change: onFilterChange }',
                        },
                    }),
                })}
                    `,
                actions: html `
                        ${LpButton({
                    label: 'Transmission Groups',
                    prefixIcon: 'stack',
                    size: 'base',
                    variant: 'secondary',
                    attributes: {
                        'data-bind': 'click: onClickGroups',
                    },
                })}
                        ${LpButton({
                    label: 'Create New Transmission',
                    prefixIcon: 'plus',
                    size: 'base',
                    variant: 'primary',
                    attributes: {
                        'data-bind': 'click: onClickCreate',
                    },
                })}
                    `,
            }),
        })}

            <div class="list-page-module transmissions-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderTransmissionsTable()}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultsInfo.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    /**
     * Build the request payload from the current view model state.
     *
     * @return object
     */
    getViewModelForRequest() {
        const vm = this.getTemplateViewModel();
        return {
            live: vm.live(),
            channel: vm.channel(),
            transmissionType: vm.transmissionType(),
            name: vm.name(),
            pagination: this.getPaginationViewModel(),
        };
    }
    /**
     * Return the pagination partial view model.
     *
     * @return any
     */
    getPaginationViewModel() {
        return this.pagination ? this.pagination.getTemplateViewModel() : null;
    }
    /**
     * Apply transmission type references to the view model.
     *
     * @param types Array<any>
     * @return void
     */
    setTypes(types) {
        this.typeFilter.setOptions([
            { id: '', name: 'All types' },
            ...(types || []).map((type) => ({
                id: String(type.id),
                name: type.name,
            })),
        ]);
    }
    /**
     * Apply channel references to the view model.
     *
     * @param channels Array<any>
     * @return void
     */
    setChannels(channels) {
        this.channelFilter.setOptions([
            { id: '', name: 'All channels' },
            ...(channels || []).map((channel) => ({
                id: String(channel.id),
                name: channel.name,
            })),
        ]);
    }
    /**
     * Apply transmission rows returned by the API to the view model.
     *
     * @param transmissions Array<any>
     * @return void
     */
    setTransmissions(transmissions) {
        this.getTemplateViewModel().transmissions((transmissions || []).map((transmission) => ({
            ...transmission,
            liveLabel: Number(transmission.live || 0) === 1 ? 'Live' : 'Not Live',
        })));
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        if (this.pagination) {
            this.pagination.setNumberItemToPaginate(totalCount);
        }
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalResults number
     * @param totalPages number
     * @param execTime number
     * @return void
     */
    setResultInfo(totalResults, totalPages, execTime) {
        this.resultsInfo.setNbResults(totalResults);
        this.resultsInfo.setNbPages(totalPages);
        this.resultsInfo.setExecutionTime(execTime);
    }
    /**
     * Reset the list pagination to the first page.
     *
     * @return void
     */
    resetPageNumber() {
        const paginationVm = this.getPaginationViewModel();
        if (paginationVm && typeof paginationVm.pageNumber === 'function') {
            paginationVm.pageNumber(1);
        }
    }
}
